/**
 * Adds the Temp status to the form when saved for later.
 */
export function saveTempForm() {
	const $formHeader = $( '.o__ime-form-header' );
	const $form = $( '.ime' );
	if ( !$formHeader.length || !$form.length ) {
		return;
	}

	const radioGroupName = $( '.form-status' ).find( 'input' ).first().attr( 'name' );
	const statusIncomplete = $formHeader.data( 'status-incomplete' );
	const statusSubmitted = $formHeader.data( 'status-submitted' );
	const $radioButtons = $( `input[name=${radioGroupName}]` );
	const $incompleteRadioInput = $( `input[name=${radioGroupName}][value=${statusIncomplete}]` );
	const $submittedRadioInput = $( `input[name=${radioGroupName}][value=${statusSubmitted}]` );
	const formId = $formHeader.data( 'form-id' );
	const $gfPageCounter = $form.find( `#gform_target_page_number_${formId}` );

	if ( !$incompleteRadioInput ) {
		console.warn( 'IME Form Fatal Error: no Incomplete Status field found.' );
		return;
	}

	const customEvent = navigator.userAgent.match( 'iPhone' ) === null ? 'pageshow' : 'popstate';

	// Prevent bug that bypassed the form validation when saving for later and going back to the form.
	$( window ).on( customEvent, function pageBack() {
		$radioButtons.prop( 'checked', false );
		$submittedRadioInput.prop( 'checked', true );
	});

	$( document ).on( 'click', '.js-save-temp-form', function saveForm() {
		// Hack to enable the form to be saved when not on the final step.
		$gfPageCounter.val( '0' );
		// Adds the Temp status to the form.
		$radioButtons.prop( 'checked', false );
		$incompleteRadioInput.prop( 'checked', true );
		// Fix fro NS-5171: Submit button needs to be visible (display != none)
		if ( $( '#gform_page_5_4' ).css( 'display' ) === 'none' ) {
			$( '#gform_page_5_4' ).addClass( 'gform_page_invisible' );
		}
		$form.submit();
	});
}
